import { t } from '@lingui/core/macro';
import { Chip } from '@pocketlaw/tetris';
import { SignRequestStatus } from 'shared/domains/apollo/generated/types';
export function ESigningStatusChip(props) {
    const { status } = props;
    switch (status) {
        case SignRequestStatus.Signed:
            return (<Chip variant="outline" appearance="success" label={t({
                    comment: 'Esigning status - Signed',
                    message: 'Completed',
                })}/>);
        case SignRequestStatus.Rejected:
            return (<Chip variant="outline" appearance="danger" label={t({
                    comment: 'Esigning status - Rejected',
                    message: 'Rejected',
                })}/>);
        case SignRequestStatus.Pending:
            return (<Chip variant="outline" appearance="info" label={t({
                    comment: 'Esigning status - Pending',
                    message: 'Pending',
                })}/>);
        default:
            return null;
    }
}
